import type {
  NextApplicantResponse,
  Response,
} from '@/lib/apollo/query/getNextApplicant/query'

import type { TransformedData, TransformedNextApplicantData } from './types'

export const toTransformedNextApplicant = (
  applicant: NextApplicantResponse,
): TransformedNextApplicantData => ({
  ...applicant,
  subjectId: applicant.subjectId ?? undefined,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : toTransformedNextApplicant(response.getNextApplicant)
